import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PageHead, Loading, Pill, BrandDot } from "@/components/common";
import { Gamepad2, Disc3 } from "lucide-react";

export default function Games() {
  const { selectedBrand } = useApp();
  const [games, setGames] = useState(null);
  const load = () => { const b = selectedBrand === "ALL" ? "" : `?brand=${selectedBrand}`; api.get(`/games${b}`).then((r) => setGames(r.data)); };
  useEffect(() => { load(); }, [selectedBrand]);
  const toggle = async (g) => { await api.patch(`/games/${g.id}`, { enabled: !g.enabled }); load(); };

  return (
    <div>
      <PageHead overline="Gaming Manager" title="Games" desc="Two formats only: Scratch Card & Spin Wheel. Server-side randomness, versioned probabilities, one entitlement = one immutable result." />
      {!games ? <Loading /> : (
        <div className="grid md:grid-cols-2 gap-5">
          {games.map((g) => {
            const total = g.slabs.reduce((a, s) => a + s.prob, 0);
            return (
              <div key={g.id} data-testid={`game-${g.id}`} className="bg-white rounded-xl border border-slate-200 p-5">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <span className="w-9 h-9 rounded-lg bg-violet-50 text-violet-600 flex items-center justify-center">{g.game_type === "spin" ? <Disc3 size={18} /> : <Gamepad2 size={18} />}</span>
                    <div><div className="font-semibold text-slate-800">{g.name}</div><div className="text-xs text-slate-400"><BrandDot id={g.brand_id} />{g.game_type} · max {g.max_plays_per_customer}/customer</div></div>
                  </div>
                  <button data-testid={`game-toggle-${g.id}`} onClick={() => toggle(g)}><Pill status={g.enabled ? "active" : "inactive"}>{g.enabled ? "Enabled" : "Paused"}</Pill></button>
                </div>
                <div className="space-y-1.5">
                  {g.slabs.map((s, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <div className="flex-1 flex items-center justify-between text-sm"><span className="text-slate-600">{s.label}</span><span className="font-semibold">{s.points > 0 ? `${s.points} pts` : "No win"}</span></div>
                      <div className="w-24 bg-slate-100 rounded-full h-2 overflow-hidden"><div className="h-full tnp-gradient" style={{ width: `${s.prob}%` }} /></div>
                      <span className="text-xs text-slate-400 w-8 text-right">{s.prob}%</span>
                    </div>
                  ))}
                </div>
                <div className={`mt-3 text-xs font-semibold ${total === 100 ? "text-emerald-600" : "text-rose-600"}`}>Probabilities sum: {total}% {total === 100 ? "✓" : "(must equal 100)"}</div>
                <div className="text-[11px] text-slate-400 mt-1">Budget: {g.used_points || 0} / {g.budget_points} pts used</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
